import React from 'react';
import { Timeline } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

import {
  handleTrackingIconStatusCode,
  handleTrackingTextStatusCode,
} from '../../../Utils/SpotUtils';
import { VertTypography } from '@vertem-core/vertice-ds';
import dayjs from 'dayjs';

export const SpotTrackingTimeline = ({ trackingHistories = [], currentTimelineStepper }) => {
  if (!trackingHistories.length) {
    return (
      <div className='timeline'>
        <Timeline.Item dot={<ClockCircleOutlined />} color='green'>
          <div className='timeline-item-content'>
            <VertTypography.Paragraph className='timeline-title'>
              Rastreio não disponível
            </VertTypography.Paragraph>
            <VertTypography.Paragraph className='timeline-description'>
              Não foi possível carregar os dados do rastreio
            </VertTypography.Paragraph>
          </div>
        </Timeline.Item>
      </div>
    );
  }

  return (
    <div>
      <Timeline className='timeline' reverse>
        {trackingHistories.map(
          ({ trackingStatusCodeId, processingDate, trackingStatusCode, notes }, index) => {
            const isLastItem = index === trackingHistories.length - 1;
            const isCurrentStepper = trackingStatusCodeId == currentTimelineStepper;

            return (
              <Timeline.Item
                key={index}
                dot={handleTrackingIconStatusCode(
                  trackingStatusCodeId,
                  isCurrentStepper && isLastItem,
                )}
                color='green'
                className='timeline-item'
              >
                <div className='timeline-item-content'>
                  {handleTrackingTextStatusCode(
                    trackingStatusCodeId,
                    isCurrentStepper && isLastItem,
                    trackingStatusCode,
                  )}
                  <VertTypography.Paragraph className={`timeline-description`}>
                    {dayjs(processingDate).format('DD/MM/YYYY [às] HH:mm [h]')}
                  </VertTypography.Paragraph>

                  {notes && (
                    <>
                      <VertTypography.Paragraph
                        className={`
                        timeline-description`}
                      >
                        {notes}
                      </VertTypography.Paragraph>
                    </>
                  )}
                </div>
              </Timeline.Item>
            );
          },
        )}
      </Timeline>
    </div>
  );
};
